import { css } from '@emotion/css';
import { Box, Group, Stack, Text } from '@mantine/core';
import { IconMail } from '@tabler/icons-react';
import dayjs from 'dayjs';
import { useHistory } from 'react-router';
import { capitalize } from 'remeda';

type EmailActivityItemProps = {
  email: {
    id: string;
    attributes: {
      from_name: string;
      from_mail: string;
      subject: string;
      date: string;
      thread_id: string;
    };
  };
};

export const EmailActivityItem = ({ email }: EmailActivityItemProps) => {
  const history = useHistory();

  const {
    attributes: { from_name, from_mail, subject, date, thread_id },
  } = email;

  const onClick = () => history.push(`/mails/${thread_id}`);

  return (
    <Box className={styles.activity}>
      <Group onClick={onClick} wrap="nowrap" align="start" px="sm" py="lg">
        <IconMail size={45} stroke={1.2} />
        <Stack gap={4}>
          <Group gap={4}>
            <Text fw={500} c="gray.10">
              {from_name} &#x3c;<a href={`mailto:${from_mail}`}>{from_mail}</a>&#x3e;
            </Text>
            <Text c="dimmed" size="sm">
              •
            </Text>
            <Text c="dimmed" size="sm">
              {capitalize(dayjs(date).format('LLL'))}
            </Text>
          </Group>
          <Text c="gray.10" classNames={{ root: styles.brandifyBold }}>
            {subject}
          </Text>
        </Stack>
      </Group>
    </Box>
  );
};

const styles = {
  brandifyBold: css`
    b {
      font-weight: 500;
      color: var(--mantine-color-purple-5);
    }
  `,
  activity: css`
    &:not(:last-child) {
      border-bottom: 1px solid var(--mantine-color-gray-3);
    }


    > div {
      transition: background-color 0.15s;
      cursor: pointer;
      background-color: transparent;
    }

    &:hover > div {
      background-color: var(--mantine-color-purple-1);
    }

    #commet-box {
      transition: background-color 0.15s;
    }

    &:hover #comment-box {
      background-color: var(--mantine-color-purple-2) !important;
    }
  `,
};
